'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"

export default {
  async getStores() {
    const data = {
      method: 'get',
      url: 'stores',
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async getStore(id) {
    const data = {
      method: 'get',
      url: 'stores/' + id,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async createStore(json) {
    const data = {
      method: 'post',
      url: 'stores',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Store created successfully')
      return true;
    }
  },
  async updateStore(json, id) {
    const data = {
      method: 'put',
      url: 'stores/' + id,
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Store updated successfully')
      return true;
    }
  },
  async getStoreNextNo(id = 'store') {
    const data = {
      method: 'get',
      url: 'stores/' + id + '/code',
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async storeGoOnline(id, json, mode) {
    const data = {
      method: 'post',
      url: 'stores/' + id + '/online',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      if (mode === 'add') {
        notify.alert.success('Store go online successful')
      } else {
        notify.alert.success('Editing store online details successful')
      }
      return true;
    }
  },
  async getDeliveryPrices(storeId) {
    const data = {
      method: 'get',
      url: 'delivery-prices/' + storeId,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
    return []
  },
  async createDeliveryPrice(json) {
    const data = {
      method: 'post',
      url: 'delivery-price',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Delivery price created successfully')
      return true;
    }
  },
  async updateDeliveryPrice(json, id) {
    const data = {
      method: 'put',
      url: 'delivery-price/' + id,
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Delivery price updated successfully')
      return true;
    }
  },
  async deleteDeliveryPrice(id) {
    const data = {
      method: 'delete',
      url: 'delivery-price/' + id,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Delivery price deleted successfully')
      return true;
    }
  },
  async getOperatingHours(storeId) {
    const data = {
      method: 'get',
      url: 'stores/' + storeId + '/operating-hours',
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
    return []
  },
  async createOperatingHours(storeId, json) {
    const data = {
      method: 'post',
      url: 'stores/' + storeId + '/operating-hours',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Operating hours created successfully')
      return true;
    }
  },
  async updateOperatingHour(storeId, operatingHourId, json) {
    const data = {
      method: 'put',
      url: 'stores/' + storeId + '/operating-hours/' + operatingHourId,
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Operating hour updated successfully')
      return true;
    }
  },
  async getAuthorizedUsers(storeId) {
    const data = {
      method: 'get',
      url: 'stores/' + storeId + '/authorized-users',
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
    return []
  },
  async addAuthorizedUser(storeId, userId) {
    const data = {
      method: 'post',
      url: 'stores/' + storeId + '/authorized-users',
      body: { user_id: userId },
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Authorized user added successfully')
      return response.data
    }
  },
  async removeAuthorizedUser(storeId, userId) {
    const data = {
      method: 'delete',
      url: 'stores/' + storeId + '/authorized-users/' + userId,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Authorized user removed successfully')
      return true;
    }
  },
}
